
import React, { ReactNode } from 'react';
import ErrorBoundary from './ErrorBoundary';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AlertTriangle, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface RouteErrorBoundaryProps {
  children: ReactNode;
  routeName?: string;
}

const RouteErrorFallback = ({ routeName }: { routeName?: string }) => {
  const navigate = useNavigate();

  return (
    <div className="container mx-auto px-4 py-16">
      <Card className="max-w-md mx-auto">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center">
            <AlertTriangle className="w-6 h-6 text-destructive" />
          </div>
          <CardTitle>Page Error</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 text-center">
          <p className="text-sm text-muted-foreground">
            There was an error loading {routeName || 'this page'}. Please try navigating back or refreshing.
          </p>
          <Button onClick={() => navigate(-1)} variant="outline" className="w-full">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Go Back
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

const RouteErrorBoundary = ({ children, routeName }: RouteErrorBoundaryProps) => {
  return (
    <ErrorBoundary fallback={<RouteErrorFallback routeName={routeName} />}>
      {children}
    </ErrorBoundary>
  );
};

export default RouteErrorBoundary;
